import React from 'react';

import { di } from 'react-magnetic-di';

import { Box } from '@atlaskit/primitives/compiled/box';
import Textfield from '@atlaskit/textfield/text-field';

import { asFormTextField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';

export const PreviewUrlInput = ({
	fieldId,
	fieldInputId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);
	const formField = useFormField({ fieldId });
	const formTextField = asFormTextField(formField);

	if (formTextField === undefined) {
		return <></>;
	}

	return (
		<Box testId="field-input-url-preview">
			<Textfield id={fieldInputId} value={formTextField.value?.text} isDisabled />
		</Box>
	);
};
